import { render, staticRenderFns } from "./fccTestesCandidato.vue?vue&type=template&id=0a52b3e0&scoped=true"
import script from "./fccTestesCandidato.vue?vue&type=script&lang=js"
export * from "./fccTestesCandidato.vue?vue&type=script&lang=js"
import style0 from "./fccTestesCandidato.vue?vue&type=style&index=0&id=0a52b3e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a52b3e0",
  null
  
)

export default component.exports